module.exports = __webpack_public_path__ + "media/step3_animation_Brueche.d827a40b.webm";